/* global ImageCropper */

import { Controller } from "@hotwired/stimulus";
import { applyImageHandling } from "../mixins/image_handling.js";
import { applyUiInteractions } from "../mixins/ui_interactions.js";

export default class extends Controller {
  initialize() {
    applyImageHandling(this);
    applyUiInteractions(this);
  }

  applyFavicon(cropper, selector, imageName) {
    const canvas = cropper.get_cropped_canvas();
    selector.attr("src", canvas.toDataURL());

    const imageType = this.getImageType(cropper.cropper);
    const file = this.dataURLtoFile(selector.attr("src"), imageName, imageType);
    const fileInput = $("#s3_favicon_form .s3-form-image-input")[0];
    const changeEvent = new Event("change");

    Object.defineProperty(fileInput, "files", {
      value: [file],
    });

    fileInput.dispatchEvent(changeEvent);
  }

  dataURLtoFile(dataurl, filename, imageType) {
    const arr = dataurl.split(",");
    const bstr = atob(arr[arr.length - 1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);
    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }
    return new File([u8arr], this.addUUIDToFileName(filename), {
      type: imageType,
    });
  }

  showProcessingLoader() {
    window.modal.close();
    $(".image-section-loading").fadeIn("fast");
    $(".logo-favicon-images").animate({ opacity: 0.1 }, "fast");
  }

  initializeFaviconCropper(container) {
    return new ImageCropper(container, {
      minCropBoxWidth: 60,
      minCropBoxHeight: 60,
      aspectRatio: 1 / 1,
      finalDimension: {
        height: 160,
        width: 160,
      },
    });
  }
}
